export default __webpack_public_path__ + "static/keyFeatureBg-ab1f0f3276b577f731e78744193fd175.png";